import React from 'react';

interface ZipCodeData {
  isCheckingZipCode: boolean;
  onClick: () => void;
  setZipCode: (string) => void;
  zipCode: string;
}

export const ZipCodeStep: React.FC<ZipCodeData> = ({ isCheckingZipCode, onClick, setZipCode, zipCode }) => {
  return (
    <section className="step zip-code contact-info">
      <div className="section-container">
        <h2 className="section-h2">Where is this home?</h2>
        <div className="form lead-form">
          <div className="form-field-wrap">
            <label>Zip Code</label>
            <input
              name="zip_code"
              onChange={e => {
                if (e.target.value.match(/[0-9]+/) || (e.target.value === '' && e.target.value.length <= 5)) {
                  setZipCode(e.target.value);
                }
              }}
              onKeyDown={e => {
                if (e.keyCode === 13) onClick();
              }}
              placeholder="Zip Code"
              value={zipCode}
            />
          </div>
        </div>
        <div>
          <button className="btn-cta mortgage-btn" onClick={onClick} type="button">
            {isCheckingZipCode && (
              <div className="loading-icon small">
                <i className="fas fa-spinner fa-spin"></i>
              </div>
            )}
            {!isCheckingZipCode && <span className="btn-label">NEXT</span>}
          </button>
        </div>
      </div>
    </section>
  );
};
